import api from '@/api'
import errors from '@/api/errors'
import store from '@/store'

const baseUrlRef = process.env.REVIEW_API_BASE_URL_REF
const baseUrlReg = process.env.REVIEW_API_BASE_URL_REG

const createGetReviewsParams = (args) => {
  const p = {}
  // required
  p.sessionID = store.getters['commons/cookies'].encsid
  p.is_image = args.isImage || '0'
  p.is_helpful = args.isHelpful || '0'
  p.is_follow = args.isFollow || '0'
  p.is_clip = args.isClip || '0'
  p.status = args.status || [ '2' ]
  p.sort = args.orderValue || '1'
  p.sort_item = args.sortValue || 0
  p.start = args.start || 0
  p.count = args.count || 0
  p.is_comment = args.isComment || '0'
  if (args.isComment) {
    p.comments = {
      start: 0,
      count: 0,
      sort: '1',
      status: [ '2' ]
    }
  }
  // non-required
  if (store.getters['commons/cookies'].mchat) {
    p.accessToken = store.getters['commons/cookies'].mchat
  }
  if (args.skuCodes) {
    p.sku_codes = args.skuCodes
  }
  if (args.nicknames) {
    p.nicknames = args.nicknames
  }
  if (args.star) {
    p.star = args.star
  }
  if (args.from) {
    p.from = args.from
  }
  if (args.to) {
    p.to = args.to
  }
  p.is_self_search = args.isSelfSearch || 0 // 0:自己情報以外を含む
  return p
}

const createGetReviewByIdParams = (args) => {
  const p = {}
  // required
  p.sessionID = store.getters['commons/cookies'].encsid
  p.review_id = args.reviewId
  // non-required
  if (store.getters['commons/cookies'].mchat) {
    p.accessToken = store.getters['commons/cookies'].mchat
  }
  if (args.nickname) {
    p.nickname = args.nickname
  }
  if (args.comments) {
    p.comments = {
      start: args.comments.start || 0,
      count: args.comments.count || 0,
      sort: args.comments.orderValue || '1',
      status: args.comments.status || [ '2' ]
    }
  }
  return p
}

const createDeleteParams = (args) => {
  const p = {}
  // required
  p.accessToken = store.getters['commons/cookies'].mchat
  p.sessionID = store.getters['commons/cookies'].encsid
  p.review_id = args.reviewId
  return p
}

const createRegistParams = (args) => {
  const p = {}
  // required
  p.accessToken = store.getters['commons/cookies'].mchat
  p.sessionID = store.getters['commons/cookies'].encsid
  p.sku_code = args.skuCode
  p.item_code = args.itemCode
  p.star = args.star
  p.caption = args.caption
  p.description = args.description
  // non-required
  if (args.image_1) {
    p.image_1 = args.image_1
  }
  if (args.image_2) {
    p.image_2 = args.image_2
  }
  if (args.image_3) {
    p.image_3 = args.image_3
  }
  if (args.image_4) {
    p.image_4 = args.image_4
  }
  if (args.image_5) {
    p.image_5 = args.image_5
  }
  p.application = 2
  p.country = process.env.COUNTRY
  p.tags = args.tags
  p.is_draft = '1'

  return p
}

const onReceived = (respBody) => {
  if (respBody.resultCode !== 0) {
    console.error(`API error code ${respBody.resultCode}`)
    if (respBody.resultCode === 611) { // アクセストークンエラー
      throw new errors.AuthenticationError()
    }
    throw new Error('問題が発生したためその後の処理を継続することができませんでした。時間を置いて再度利用をお願いします。')
  }
  return Promise.resolve(respBody.data)
}

const onResistReviewResult = (respBody) => {
  if (respBody.resultCode !== 0) {
    console.error(`API error code ${respBody.resultCode}`)
    if (respBody.resultCode === 611) { // アクセストークンエラー
      throw new errors.AuthenticationError()
    }
    if (respBody.resultCode === 105) { // バリデーションエラー
      throw new errors.InputValidationError(respBody.errorMessage)
    }
    throw new Error('問題が発生したためその後の処理を継続することができませんでした。時間を置いて再度利用をお願いします。')
  }
  return Promise.resolve(respBody.data)
}

export default {
  // レビュー取得 (一覧)
  getReviews: (args) => {
    const params = createGetReviewsParams(args)
    return api.post(`${baseUrlRef}/getItemReview`, params).then(onReceived)
  },
  // レビュー取得 (ID指定)
  getReviewById: (args) => {
    const params = createGetReviewByIdParams(args)
    return api.post(`${baseUrlRef}/getReview`, params).then(onReceived)
  },
  // レビュー削除
  deleteReview: (args) => {
    const params = createDeleteParams(args)
    return api.post(`${baseUrlReg}/deleteItemReview`, params).then(onReceived)
  },
  // レビュー登録
  registReview: (args) => {
    const params = createRegistParams(args)
    return api.post(`${baseUrlReg}/registItemReview`, params).then(onResistReviewResult)
  },
  getRegistParams: (args) => {
    return createRegistParams(args)
  }
}



// WEBPACK FOOTER //
// ./src/api/reviews.js